import React from "react";

// state
import { get_documents } from "../../../service/api/document";

// dispatch
import { useNavigate } from "react-router-dom";
import { setTitle } from "../../../store/slices/navbar";
import { useAppDispatch, useAppSelector } from "../../../store";

// Import Swiper styles
// import "swiper/css";
import AnimatedPage from "../../../components/animation/AnimatedPage";
import Button from "../../../components/elements/form/Button";
import FileData from "../misc/FileData";
import MobileFileCard from "../misc/MobileFileCard";
import { IDocument } from "../../../store/@types/document";

//icons
import { IconFileText } from "@tabler/icons-react";
import { Loader } from "../../../components/animation/Loader";
import { useMediaQuery } from "../../../hooks/useMediaQuery";

const Documents = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const documents = useAppSelector(({ document }) => document.documents);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const current_page = useAppSelector(({ document }) => document.current_page);
  const user = useAppSelector(({ auth }) => auth.user);
  const loading = useAppSelector(({ document }) => document.loading);

  const onLoad = React.useCallback(() => {
    dispatch(setTitle("Documents"));
    get_documents(dispatch, current_page);
  }, [current_page, dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  const hasPermission = user && user?.role === "1";

  return (
    <AnimatedPage>
      <div>
        {documents.length === 0 ? (
          <div className="h-[calc(100vh-200px)] flex flex-col items-center justify-center">
            <div className="w-full flex flex-col items-center justify-center gap-4 mb-4">
              <div className="bg-gray-50 rounded-full p-6">
                <IconFileText size={48} className="text-gray-400" />
              </div>
              <div className="text-center">
                <p className="text-gray-600 font-medium text-lg">
                  No documents found
                </p>
                <p className="text-gray-400 text-sm mt-1">
                  {hasPermission
                    ? "Upload a document to get started"
                    : "No documents available at this time"}
                </p>
              </div>
            </div>
            {hasPermission && (
              <Button
                title="Upload Document"
                bg_color="bg-primary-500 hover:bg-primary-900 rounded-lg"
                text_color="text-white"
                onHandler={() => navigate("/dashboard/documents/upload")}
                className="w-fit"
              />
            )}
          </div>
        ) : loading ? (
          <Loader />
        ) : (
          <>
            {hasPermission && (
              <div className="mb-6">
                <Button
                  title="Upload Document"
                  bg_color="bg-primary-500 hover:bg-primary-900 rounded-lg"
                  text_color="text-white"
                  onHandler={() => navigate("/dashboard/documents/upload")}
                  className="w-fit"
                />
              </div>
            )}
            <div className="w-full">
              {documents.map((document: IDocument) =>
                isMobile ? (
                  <MobileFileCard item={document} key={document.id} />
                ) : (
                  <FileData item={document} key={document.id} />
                ),
              )}
            </div>
          </>
        )}
      </div>
    </AnimatedPage>
  );
};

export default Documents;
